/* eslint-disable */
import { useState } from 'react';

import { Handle } from 'reactflow';

import { useForm } from "react-hook-form";
import SideModal from '../components/SideModal';

export default function CustomRuleBox({ event, items_ul2, onConnect, setNodes }) {
    const { register, handleSubmit, reset } = useForm();


    const id = event.id;
    const type = event.data.value.type
    const rules = event.data.value.custom_rule || []


    const onSubmit = (data) => {
        const ruleList = [...rules, data.inputText]
        setNodes(nds => {
            return nds.map(node => {
                if (node.id == id) {
                    node.data.value.custom_rule = ruleList
                }
                return node
            })
        })
        reset();
        console.log(event.data)


    };


   

    const typesMap = {
        "default": { "all": "All" },
        "sms": { "sms_deliver": "Sms Deliver", "sms_failed": "Sms Failed" },
        "mail": { "mail_deliver": "Email Deliver", "mail_failed": "Email Failed",  "mail_open": "Email Open",  "mail_sent": "Email Sent" },
        "voice": {"voice_deliver": "Voice Deliver", "voice_fail": "Voice Fail" },
        "whatsapp": { "all": "All", "whatsapp_deliver": "WhatsApp Deliver", "whatsapp_read": "WhatsApp Read", "whatsapp_fail": "WhatsApp Fail" },
        "wa_message": { "all": "All", "wa_message_deliver": "WA Message Deliver", "wa_message_read": "WA Message Read", "wa_message_fail": "WA Message Fail", "wa_message_reply": "WA Message reply" }
    };

    const options = Object.entries(typesMap[type] || []);

    if (options.length != 0) {
        return (
            <>
                {
                    options.map(([key, label]) => {
                        return (
                            <div className="row px-2.5">
                                <div className="col-md-12">
                                    <div className='flex mb-2'>
                                        <div className="Button_div_box ">
                                            <p>{label}</p>
                                        </div>
                                        <div className="downBtnPlus">
                                            <SideModal
                                                cond={key}
                                                id={`rule-${key}`}
                                                event={event}
                                                items_ul2={items_ul2}
                                                typo="start_btn_new"
                                                modelType="none"
                                            />
                                            <Handle
                                                type="source" position="right" id={`rule-${key}`} className="right_main main_point"
                                                onConnect={(params) => onConnect({ ...params, "cond": key, datas: event })}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )
                    })
                }
                {
                    rules.map(i => {
                        return (
                            <div className="row px-2.5">
                                <div className="col-md-12">
                                    <div className='flex mb-2'>
                                        <div className="Button_div_box ">
                                            <p>{i} Reply</p>
                                        </div>
                                        <div className="downBtnPlus">
                                            <SideModal
                                                cond={`${i} reply`}
                                                id={`rule-${i}_reply`}
                                                event={event}
                                                items_ul2={items_ul2}
                                                typo="start_btn_new"
                                                modelType="none"
                                            />
                                            <Handle
                                                type="source" position="right" id={`rule-${i}_reply`} className="right_main main_point"
                                                onConnect={(params) => onConnect({ ...params, "cond": `${i} reply`, datas: event })}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )
                    })
                }

                {/* <form onSubmit={handleSubmit(onSubmit)}>
                    <div className='row px-2.5 mb-2'>
                        <div className='col-md-9'>
                            <input placeholder='Add Custom Rule' className='form-control' {...register('inputText', { required: true })} />
                        </div>
                        <div className='col-md-1'>
                            <button type='submit' className='btn btn-sm btn-info'>Add</button>
                        </div>
                    </div>
                </form> */}
            </>
        )
    }


}